import { useState, useEffect } from "react";
import { loadShiftCode } from "../services/shiftService";

const useShiftCode = (editShiftAssignmentID) => {
    const [shiftCode, setShiftCode] = useState([]);
    const [selectedShiftCode, setSelectedShiftCode] = useState(null);
    const [selectedShiftCodeID, setSelectedShiftCodeID] = useState(null);
    const [isShiftCodeDataLoaded, setIsShiftCodeDataLoaded] = useState(false);

    // Fetch department data
    const fetchShiftCode = async (selectedID = null) => {
        const para = { p_companyid: localStorage.getItem("companyid") };

        try {

            const data = await loadShiftCode(para);

            if (data && data.length > 0) {
                setShiftCode(data);

                const initialShiftCode = data.find((dept) => dept.shiftid === selectedID);                
                if (initialShiftCode?.length > 0) {
                    setSelectedShiftCode(initialShiftCode);
                    setSelectedShiftCodeID(initialShiftCode.shiftid);
                    setIsShiftCodeDataLoaded(true);
                }

            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isShiftCodeDataLoaded && editShiftAssignmentID === 0) {
            fetchShiftCode();
        }
    }, [isShiftCodeDataLoaded, editShiftAssignmentID]);

    // Function to load department based on selected ID
    const loadShiftCodeByID = async (selectedID) => {
        await fetchShiftCode(selectedID);
    };

    return {
        shiftCode,
        selectedShiftCode,
        selectedShiftCodeID,
        setSelectedShiftCode,
        setSelectedShiftCodeID,
        loadShiftCodeByID,
    };
};

export default useShiftCode;